<app-pageheader [Parent]="this"></app-pageheader>

<!-- Filters Section -->
<div class="card mb-4">
  <div class="card-content">
    <div class="columns is-vcentered">
      <div class="column is-3">
        <label class="label">Officer</label>
        <div class="select is-fullwidth">
          <select [(ngModel)]="selectedOfficerId" (change)="onFilterChange()">
            <option [ngValue]="null">All Officers</option>
            @for (officer of officers; track officer) {
              <option [ngValue]="officer.id">
                {{ officer.displayName }}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="column is-3">
        <label class="label">Start Date</label>
        <input
          type="date"
          class="input"
          [(ngModel)]="startDate"
          (change)="onFilterChange()"
          />
        </div>
        <div class="column is-3">
          <label class="label">End Date</label>
          <input
            type="date"
            class="input"
            [(ngModel)]="endDate"
            (change)="onFilterChange()"
            />
          </div>
          <div class="column is-3">
            <label class="label">Group By</label>
            <div class="select is-fullwidth">
              <select [(ngModel)]="groupBy" (change)="onFilterChange()">
                <option value="day">Day</option>
                <option value="week">Week</option>
                <option value="month">Month</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-loader [Parent]="this"></app-loader>

    @if (statistics && statistics.summary) {
      <div>
        <!-- Summary Stats Cards -->
        <div class="columns is-multiline mb-4">
          <div class="column is-2">
            <div class="card stat-card">
              <div class="card-content has-text-centered">
                <div class="green-bg tag is-large is-rounded">
                  <p class="numbers">{{ formatNumber(statistics.summary.totalCitations || 0) }}</p>
                </div>
                <p class="stat-label">Total Citations</p>
              </div>
            </div>
          </div>
          <div class="column is-2">
            <div class="card stat-card">
              <div class="card-content has-text-centered">
                <div class="green-bg tag is-large is-rounded">
                  <p class="numbers">{{ formatCurrency(statistics.summary.totalRevenue || 0) }}</p>
                </div>
                <p class="stat-label">Revenue Collected</p>
              </div>
            </div>
          </div>
          <div class="column is-2">
            <div class="card stat-card">
              <div class="card-content has-text-centered">
                <div class="green-bg tag is-large is-rounded">
                  <p class="numbers">{{ formatCurrency(statistics.summary.totalOutstanding || 0) }}</p>
                </div>
                <p class="stat-label">Outstanding</p>
              </div>
            </div>
          </div>
          <div class="column is-2">
            <div class="card stat-card">
              <div class="card-content has-text-centered">
                <div class="green-bg tag is-large is-rounded">
                  <p class="numbers">{{ formatPercent(statistics.summary.collectionRatePercentage || 0) }}</p>
                </div>
                <p class="stat-label">Collection Rate</p>
              </div>
            </div>
          </div>
          <div class="column is-2">
            <div class="card stat-card">
              <div class="card-content has-text-centered">
                <div class="green-bg tag is-large is-rounded">
                  <p class="numbers">{{ formatPercent(statistics.summary.paidPercentage || 0) }}</p>
                </div>
                <p class="stat-label">Paid Rate</p>
              </div>
            </div>
          </div>
          <div class="column is-2">
            <div class="card stat-card">
              <div class="card-content has-text-centered">
                <div class="green-bg tag is-large is-rounded">
                  <p class="numbers">{{ formatPercent(statistics.summary.voidedCountsAgainstPerformancePercentage || 0) }}</p>
                </div>
                <p class="stat-label">Performance Issues</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Large Charts Row (2 charts) -->
        <div class="columns">
          <div class="column is-6">
            <div class="card chart-card">
              <div class="card-content">
                @if (revenueChartData) {
                  <app-generic-bar-chart
                    [chartData]="revenueChartData"
                    [title]="'Revenue Over Time'"
                    [height]="350"
                    [yAxisLabel]="'Revenue ($)'"
                    [showLegend]="false">
                  </app-generic-bar-chart>
                }
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="card chart-card">
              <div class="card-content">
                @if (citationsChartData) {
                  <app-generic-bar-chart
                    [chartData]="citationsChartData"
                    [title]="'Citations Over Time'"
                    [height]="350"
                    [yAxisLabel]="'Number of Citations'"
                    [showLegend]="false">
                  </app-generic-bar-chart>
                }
              </div>
            </div>
          </div>
        </div>
        <!-- Smaller Charts Row (3 charts) -->
        <div class="columns">
          <div class="column is-4">
            <div class="card chart-card">
              <div class="card-content">
                @if (statusBreakdownChartData) {
                  <app-generic-pie-chart
                    [chartData]="statusBreakdownChartData"
                    [title]="'Citation Status Breakdown'"
                    [height]="300">
                  </app-generic-pie-chart>
                }
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="card chart-card">
              <div class="card-content">
                @if (infringementTypeChartData) {
                  <app-generic-pie-chart
                    [chartData]="infringementTypeChartData"
                    [title]="'Top Infringement Types'"
                    [height]="300">
                  </app-generic-pie-chart>
                }
              </div>
            </div>
          </div>
          <div class="column is-4">
            @if (statistics.officerPerformance.length > 0) {
              <div class="card chart-card">
                <div class="card-content">
                  @if (officerPerformanceChartData) {
                    <app-generic-bar-chart
                      [chartData]="officerPerformanceChartData"
                      [title]="'Officer Performance'"
                      [height]="300"
                      [yAxisLabel]="'Citations / Score'"
                      [showLegend]="true">
                    </app-generic-bar-chart>
                  }
                </div>
              </div>
            }
            @if (statistics.officerPerformance.length === 0) {
              <div class="card chart-card">
                <div class="card-content has-text-centered" style="height: 300px; display: flex; align-items: center; justify-content: center;">
                  <div>
                    <p class="is-size-5 has-text-grey">Officer Performance</p>
                    <p class="has-text-grey-light mt-2">
                      <i class="fas fa-user-tie fa-3x mb-3"></i><br>
                      No officer data available for the selected period
                    </p>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        <!-- Officer Performance Table -->
        @if (statistics.officerPerformance.length > 0 && !selectedOfficerId) {
          <div class="card mt-4">
            <header class="card-header">
              <p class="card-header-title">
                <i class="fas fa-users mr-2"></i>
                Officer Performance Rankings
              </p>
            </header>
            <div class="card-content">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Officer</th>
                    <th class="has-text-right">Total Citations</th>
                    <th class="has-text-right">Paid</th>
                    <th class="has-text-right">Voided</th>
                    <th class="has-text-right">Performance Issues</th>
                    <th class="has-text-right">Revenue</th>
                    <th class="has-text-centered">Performance Score</th>
                  </tr>
                </thead>
                <tbody>
                  @for (officer of statistics.officerPerformance; track officer; let i = $index) {
                    <tr>
                      <td>
              <span class="tag" [ngClass]="{
                'is-success': i === 0,
                'is-info': i === 1,
                'is-warning': i === 2,
                'is-light': i > 2
              }">
                          {{ i + 1 }}
                        </span>
                      </td>
                      <td>
                        <strong>{{ officer.officerName }}</strong>
                      </td>
                      <td class="has-text-right">{{ formatNumber(officer.totalCitations) }}</td>
                      <td class="has-text-right has-text-success">{{ formatNumber(officer.paidCitations) }}</td>
                      <td class="has-text-right has-text-grey">{{ formatNumber(officer.voidedCitations) }}</td>
                      <td class="has-text-right" [ngClass]="{'has-text-danger': officer.voidedCountsAgainstPerformance > 0}">
                        {{ formatNumber(officer.voidedCountsAgainstPerformance) }}
                      </td>
                      <td class="has-text-right has-text-success">{{ formatCurrency(officer.revenue) }}</td>
                      <td class="has-text-centered">
              <span class="tag is-medium" [ngClass]="{
                'is-success': officer.performanceScore >= 95,
                'is-info': officer.performanceScore >= 90 && officer.performanceScore < 95,
                'is-warning': officer.performanceScore >= 80 && officer.performanceScore < 90,
                'is-danger': officer.performanceScore < 80
              }">
                          {{ formatPercent(officer.performanceScore) }}
                        </span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    }

    <!-- Empty State -->
    @if (!statistics && !IsBusy) {
      <div class="has-text-centered p-6">
        <i class="fas fa-chart-bar fa-4x has-text-grey-light mb-4"></i>
        <p class="is-size-4 has-text-grey">No statistics available</p>
        <p class="has-text-grey-light">Try adjusting the date range or filters</p>
      </div>
    }

